import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { UserDto } from './../../../../../data/src/lib/dto/user.dto';
import {  IdentityUser } from '@cradua/domain';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import Swal from 'sweetalert2';

import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';

import { AuthService } from '../../services/auth.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageComponent implements OnInit {
  public href: string = "";

  changePassowrdform: FormGroup

  userId: string = "";
  Users: IdentityUser[] = [];
  User: IdentityUser;
  tokenIsValid: boolean = false;
  tokenIsExpire: boolean = false;
  passwordMissMatch: boolean = false;
  isForgotPassword: boolean = true;
  userEmail: string = "";
  password: string = '';
  confirmedPassword: string = '';
  token: string = "";
  submitted = false;
  forgotsubmitted = false;
  userUpdate: UserDto = {

    id: '',
	Id: '',
	UserName: '',
	PhoneNo: '',

	password: '',

	Email: '',
	UserType: '',
	SubscriberName: '',
	FirstName: '',
	LastName: '',
	MiddleName: '',
	StaffName: '',
	Logo: '',
	VerifyStatus: '',
	IsConfirmed: '',
	UIN: '',
	NewUser: '',
	spouseName: '',
	noOfChildren: 0,
	address: '',
	gender: '',
	ocupation: '',
	userRole: '',
	slogan: '',
	siteId: '',
	siteName: '',
	siteNumber: '',
	levelCount: 0,
	canAddSub: false,
	siteGenericNumber: '',
	systemAdminStatus: '',
	resetPasswordToken: '',
	resetPasswordExpires: new Date(),
  ParentId: '',
  SubscriberId: '',
  SiteId: '',
  ModifiedById: '',
  };

  form: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),

  });







  constructor(private fb: FormBuilder, private route: ActivatedRoute, private gatewayFacade: GatewayFacade,public gatewayService: GatewayService,public authService: AuthService,
    private _router: Router) {

    this.route.params.subscribe( params => {

      //console.log("Param ",params, params.id)

      if(params.id !== undefined)
      {
       this.isForgotPassword = false;
      }

      this.userId = params.id;
      this.token = params.token;

    } );

  }

  ngOnInit() {


    this.changePassowrdform = this.fb.group({

      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]

  }, {
      validator: this.MustMatch('password', 'confirmPassword')
  });


  this.loadAllUsers();

  let location =  window.location.href.split('#')[0];

  this.href = location;

  console.log( window.location.href, location);

  }

  get f() { return this.changePassowrdform.controls; }

  get forgotpass() { return this.form.controls; }


  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

  loadAllUsers(){


     if(this.userId !== ""){

      // Get User By UserId


      //console.log("Gotten User ", this.userId );



        this.gatewayService.getUserById('IdentityUser',this.userId ).subscribe((data) => {

        this.Users = data;


        //console.log("Gotten User New ", this.userId, this.Users );


        let getUser = this.Users.find(n => n.Id === this.userId);
         this.User = Object.assign({},getUser) ;

         if(this.User !== undefined)
         {
          //let
          this.userUpdate.Id =  this.User.Id;
          this.userUpdate.id = this.User.Id;
          this.userUpdate.Email = this.User.Email;
          this.userUpdate.UserName = this.User.UserName;
          this.userUpdate.PhoneNo = this.User.PhoneNo;
          this.userUpdate.StaffName = this.User.StaffName;

          var varDate = new Date(this.User.resetPasswordExpires); //dd-mm-YYYY
          var today = new Date();

          if(varDate.getTime() >= today.getTime()) {
            this.tokenIsExpire = false;
          }else{
            this.tokenIsExpire = true;
            // Show Message
          }

          //console.log("Gotten Date ", this.User  )



          if(this.token === this.User.resetPasswordToken ){
            this.tokenIsValid = true;

          }else{
            this.tokenIsValid = false;
            // Show Message
          }


         // console.log("Token Prop ", this.token, this.tokenIsExpire, this.tokenIsValid);

         }


        //console.log("IdentityUser ", data, getUser, this.userUpdate);

      });



     }


    // this.gatewayService.getAllIdentityUser("IdentityUser").subscribe((data) => {

    //    if(data.length > 0 )
    //    {



    // }
    // });

  }

  formInputChange(){
    this.submitted = false;
  }

  formForgotInputChange(){
    this.forgotsubmitted = false;
  }

  changePassword(){


    this.submitted = true;

    // stop here if form is invalid
    if (this.changePassowrdform.invalid) {

         console.log("Not Valid ");
        return;
    }

    this.password = this.changePassowrdform.value.password;
    this.confirmedPassword = this.changePassowrdform.value.confirmPassword;

    if(this.password !== '')
    {
      console.log("Password is not empty ", this.confirmedPassword, this.password);
      if(this.confirmedPassword === this.password)
      {

       // let password = "ThankYouJesus";

       console.log("Reaching Click ");

       this.gatewayService.isLoading$.next(true);
        this.userUpdate.password = this.password;

        console.log("User for Update ", this.userUpdate);
         this.gatewayFacade.update("IdentityUser",[this.userUpdate], []);

         this.gatewayService.isLoading$.pipe(take(2)).subscribe((val) => {

          // console.log("Is Loading value ", val);
             if(val === false)
             {
               //this._router.navigate(['/auth/login'])
             }

        })

      }else{
        this.passwordMissMatch = true;
        // Show Message
      }
    }else{

      Swal.fire(
        'No Password!',
        'Please enter password to continue.',
        'warning'
      );
    }

    // hash password here and update with gateway
    // Always genearte a token and send with every password request




    // let confirmedPassword = aspnetidentity.hashPassword(password);
    // this.User.PasswordHash = confirmedPassword;
  }

   generateRandomString (length, randomString="") {
    randomString += Math.random().toString(20).substr(2, length);
    if (randomString.length > length) return randomString.slice(0, length);
    return this.generateRandomString(length, randomString);
  };

  forgotPassword(){



    this.forgotsubmitted = true;

    // stop here if form is invalid

    console.log("Reaching Forgot Password", this.form.invalid);
    if (this.form.invalid) {
        return;
    }

     this.userEmail = this.form.value.username;



     console.log("Check Email ", this.userEmail ,this.userUpdate.Email)

    if(this.userEmail !== ''){

        this.gatewayService.isLoading$.next(true);

      this.gatewayService.getUserByEmail('IdentityUser',this.userEmail ).subscribe((data) => {

          this.Users = data;

          let foundUser = this.Users.find(n => n.Email === this.userEmail.toLowerCase());

          if(foundUser !== undefined){

           this.userUpdate.Id =  foundUser.Id;
           this.userUpdate.id = foundUser.Id;
           this.userUpdate.Email = foundUser.Email;
           this.userUpdate.UserName = foundUser.UserName;
           this.userUpdate.PhoneNo = foundUser.PhoneNo;
           this.userUpdate.StaffName = foundUser.StaffName;



           let  dateexpiring = new Date();
           dateexpiring.setDate(dateexpiring.getDate() + 2);


            this.userUpdate.resetPasswordExpires = dateexpiring;
            this.userUpdate.resetPasswordToken = this.generateRandomString(35);




             // Send Mail with Link


             let mailData = { fromEmail: '', toEmail: this.userEmail, subject: 'Manage Account', task:'', responsibility: '',
                     pipelinename: '', pipelinerequestdesc: '', period: '', message: '', salutation: '', footer: '', url: ''};

                     let salute = "Dear " + this.userUpdate.StaffName + ' ,';

                     let conformButtonMsg = "";


                     mailData.salutation = salute;
                     let linkURL = this.href + '#/auth/manage/' + this.userUpdate.id + '/' + this.userUpdate.resetPasswordToken;

                     mailData.message = "Click on the link below to change your access credentials. " + linkURL;

                     mailData.footer = '';



                    mailData.url = linkURL;

                    console.log("Sending mail ", mailData);
                     this.gatewayService.sendManageAccountMail(mailData).subscribe((data) => {

                    });


                    console.log("User for Update ", this.userUpdate);
                    this.gatewayFacade.update("IdentityUser",[this.userUpdate], []);


          }else{
           Swal.fire(
             'Not Found!',
             'Sorry, the email supplied does not exist.',
             'warning'
           );

          }

          this.gatewayService.isLoading$.next(false);

      })





    }else{
      Swal.fire(
        'No Email!',
        'Please enter an email address to continue.',
        'warning'
      );
    }






  }

  login(){

  }

}
